export default "__VITE_ASSET__T4F70ZZs__"